import React from 'react';
import { Box, Typography } from '@mui/material';

export default function Header() {
  return (
    <Box sx={{ mb: 4 }}>
      {/* Page Title */}
      <Typography
        variant='h3'
        sx={{
          fontWeight: 700,
          color: '#0F172A',
          fontSize: { xs: '2rem', md: '2.5rem' },
          lineHeight: 1.2,
          mb: 1,
        }}
      >
        Allocation Status Monitoring
      </Typography>

      {/* Subtitle */}
      <Typography
        sx={{
          color: '#64748B',
          fontSize: 16,
          lineHeight: 1.6,
          maxWidth: 900,
        }}
      >
        Track and update delivery status per medrep. Aggregates product counts across all of a
        medrep's assigned MDs.
      </Typography>
    </Box>
  );
}
